import { render, staticRenderFns } from "./TenantInfoSetup.vue?vue&type=template&id=16c1018b&"
import script from "./TenantInfoSetup.vue?vue&type=script&lang=ts&"
export * from "./TenantInfoSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports